import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import ArticleBody from '../ArticleBody';
import messages from '../../../messages';
const QuietQuitting = () => (
  <div>
    <ArticleBody>
      <FormattedHTMLMessage tagName="p" {...messages.quietQuittingBody} />
    </ArticleBody>
  </div>
);

QuietQuitting.propTypes = {};

export default QuietQuitting;
